import AdminSidebar from '../stylemix-vue-admin/core/interface/sidebar'

// for companies
AdminSidebar.pushItem({
  id: 'company-pricings',
  order: 20,
  text: ($vm) => {
    return $vm.$t('company.your_prices')
  },
  route: {
    name: 'company-pricings',
  },
  icon: 'icon-coin-dollar',
  permission($vm) {
    return !$vm.$allows('administer') && $vm.$allows('update company prices')
  },
  children: [
    {
      id: 'company-pricings.city_taxi',
      text: ($vm) => $vm.$t('enums.ride_type.city_taxi'),
      icon: 'icon-city',
      route: {
        name: 'company-pricings.city-taxi',
      },
    },
    {
      id: 'company-pricings.transfer',
      text: ($vm) => $vm.$t('enums.ride_type.transfer'),
      icon: 'icon-airplane2',
      route: {
        name: 'company-pricings.transfer',
      },
    },
  ],
})

// for admin
// separate cause permission not supported in children
AdminSidebar.pushItem({
  id: 'company-pricings.admin',
  order: 20,
  header: ($vm) => $vm.$t('general.menu_management'),
  text: ($vm) => {
    return $vm.$t('companies.company_prices')
  },
  route: {
    name: 'company-pricings',
  },
  icon: 'icon-coin-dollar',
  permission($vm) {
    return $vm.$allows('administer')
  },
  children: [
    {
      id: 'company-pricings.city_taxi',
      text: ($vm) => $vm.$t('enums.ride_type.city_taxi'),
      icon: 'icon-city',
      route: {
        name: 'company-pricings.city-taxi.index',
      },
    },
    {
      id: 'company-pricings.transfer',
      text: ($vm) => $vm.$t('enums.ride_type.transfer'),
      icon: 'icon-airplane2',
      route: {
        name: 'company-pricings.transfer.index',
      },
    },
  ],
})
